import React, { useState } from "react";
import ReactDOM from "react-dom";

interface ModalProps {
	modalTitle: string;
	children: React.ReactNode;
}

export interface ModalCrudProps<T> {
	showModal: boolean;
	toggleModal: () => void;
	item?: T;
}

const Modal: React.FC<ModalProps> = ({ modalTitle, children }) => {
	return (
		<>
			{ReactDOM.createPortal(
				<div className="modal">
					<div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
						<div className="relative w-auto my-6 mx-auto max-w-lg md:min-w-lg">
							{/*content*/}
							<div className="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
								{/*header*/}
								<div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
									<h3 className="text-xl font-semibold">
										{modalTitle}
									</h3>
								</div>
								{/*body*/}
								{children}
							</div>
						</div>
					</div>
					<div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
				</div>,
				document.body
			)}
		</>
	);
};

export const useModal = () => {
	const [showModal, setShowModal] = useState<boolean>(false);

	const toggleModal = () => {
		setShowModal((showModal) => !showModal);
	};

	return {
		showModal,
		toggleModal,
	};
};

export default Modal;
